module.exports = __webpack_public_path__ + "static/media/P2_S6_1.a3bf82aa.png";